import { Component, OnInit, OnDestroy,ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';

@Component({
  selector: 'app-inboxcontatos',
  templateUrl: './inboxcontatos.component.html',
  styleUrls: ['./inboxcontatos.component.css']
})
export class InboxcontatosComponent implements OnInit {
  @ViewChild("inputSearch") meuinputSearch: ElementRef;
  inputsearch: any = '';
  hideCL: boolean = false;
  nomeCidade: any = '';
  nomeUF: any = '';
  qBuscado: any = '';
  urlFoto: any = '';
  arrContatos: any[] = [];
  arrEuSigo: any[] = [];
  arrMeSegue: any[] = [];
  qIndex: any = 0;

  arrTorcendo: any[] = [];
  arrTorcedores: any[] = [];
  indexTorcendo: any = 0;
  indexTorcedores: any = 0;
  loadMoreTD: boolean = true;
  loadMoreTS: boolean = true;
  qtyTD: any = 0;
  qtyTS: any = 0;
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog) { }

  ngOnInit() {
    this.hideCL = true;
    this.tmaService.eventoFS(true);
    //this.obterResultados();
    this.listarNetwork('todos');
  }
  ngOnDestroy(){
    console.log("destroy");
    this.tmaService.eventoFS(false);
    this.tmaService.gBackBusca = true;
  }

  modifiers(s: any): any{
      var r=s.toLowerCase();
      r = r.replace(new RegExp("\\s", 'g'),"");
      r = r.replace(new RegExp("[àáâãäå]", 'g'),"a");
      r = r.replace(new RegExp("æ", 'g'),"ae");
      r = r.replace(new RegExp("ç", 'g'),"c");
      r = r.replace(new RegExp("[èéêë]", 'g'),"e");
      r = r.replace(new RegExp("[ìíîï]", 'g'),"i");
      r = r.replace(new RegExp("ñ", 'g'),"n");                            
      r = r.replace(new RegExp("[òóôõö]", 'g'),"o");
      r = r.replace(new RegExp("œ", 'g'),"oe");
      r = r.replace(new RegExp("[ùúûü]", 'g'),"u");
      r = r.replace(new RegExp("[ýÿ]", 'g'),"y");
      r = r.replace(new RegExp("\\W", 'g'),"");
      return r;
  };

  
  digitando(textoBusca: any): void {

  }

  obterResultados() :void{
    //this.arrContatos = [];
    this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      meuindex: this.qIndex
    };
    this.tmaService.listarMeusContatos(customParams).subscribe((qRes) => {
      this.hideCL = true;
      console.log(qRes);
      if (qRes['res'] == 'done') {
        this.arrMeSegue = qRes['arrMesegue'];
        this.arrEuSigo = qRes['arrEuSigo'];
        this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
      }
      else {
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: "Aviso", textoAlerta: "Ocorreu um erro ao realizar esta operação Tente novamente", iconAlerta: 'warning' }
        })
      }
    },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: "Aviso", textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
        });
      })
  }



  listarNetwork(tipobusca: any) :void{

    var indexBuscar = 0;

    if(tipobusca == 'torcendo') indexBuscar = this.indexTorcendo;
    if(tipobusca == 'torcedores') indexBuscar = this.indexTorcedores;

    this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      meuindex: indexBuscar,
      nomeusuario: this.tmaService.hcNomeUsuario,
      tipo: tipobusca
    };
    this.tmaService.listarNetWork(customParams).subscribe((qRes) => {
      this.hideCL = true;
      console.log(qRes);
      if (qRes['res'] == 'done') {
        if(tipobusca == 'todos'){
          this.arrTorcendo = this.arrTorcendo.concat(qRes['arrEuSigo']);
          this.arrTorcedores = this.arrTorcedores.concat(qRes['arrMesegue']);
          this.indexTorcedores += qRes['arrMesegue'].length;
          this.indexTorcendo += qRes['arrEuSigo'].length;
          this.qtyTD = qRes['qtdSigo'];
          this.qtyTS = qRes['qtdSegue'];
          if(qRes['arrEuSigo'].length < 10){
            this.loadMoreTD = false;
          }
          if(qRes['arrMesegue'].length < 10){
            this.loadMoreTS = false;
          }
        }

        if(tipobusca == 'torcedores'){
          this.arrTorcedores = this.arrTorcedores.concat(qRes['arrMesegue']);
          this.indexTorcedores += qRes['arrMesegue'].length;
          if(qRes['arrMesegue'].length < 10){
            this.loadMoreTS = false;
          }
        }

        if(tipobusca == 'torcendo'){
          this.arrTorcendo = this.arrTorcendo.concat(qRes['arrEuSigo']);
          this.indexTorcendo += qRes['arrEuSigo'].length;
          if(qRes['arrEuSigo'].length < 10){
            this.loadMoreTD = false;
          }
        }
        
        this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
      }
      else {
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: "Aviso", textoAlerta: "Ocorreu um erro ao realizar esta operação Tente novamente", iconAlerta: 'warning' }
        })
      }
    },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: "Aviso", textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
        });
      })

  }

  pesquisar() :void{
    
  }
  novaPesquisa() :void{
    this.router.navigate(['/pesquisando/pessoas']);
  }
  
  goChat(nomeusuario : any) :void{
    this.tmaService.paginaAnterior = 'me/contatos/listar';
    this.router.navigate(['/me/i/' + nomeusuario], {replaceUrl: true});
  }

  voltar() :void{
    this.router.navigate(['/me/inbox']);
    //this._location.back();
  }
}

